export default "__VITE_ASSET__BEz4S1aL__"